export const CHATBOT_ONBOARDING_WORKFLOW_KEY = 'chatbot_onboarding';

export const CHATBOT_ONBOARDING_STEPS = [
 {
    id: 'test_chatbot',
    apiIds: ['try_chatbot', 'set_welcome_message'],
    title: 'Send your first message',
    description: 'Ask your Agent anything about your website.',
    completedTitle: 'Nice, your Agent just answered you',
    completedDescription: 'Try a harder one. It handles follow-ups too.',
    getPath: (kbId) => `/chatbot/${kbId}/preview`
  },
  {
    id: 'ask_3_questions',
    apiIds: ['ask_3_questions'],
    title: 'Ask 3 questions',
    getTitle: (questionsAsked) => {
      const current = Math.min(questionsAsked, 2);
      return `Ask 3 questions (${current}/3)`;
    },
    description: 'See how much your Agent already knows.',
    completedTitle: '3 for 3, your Agent nailed it',
    completedDescription: 'Now give it a personality to make it yours.',
    getPath: (kbId) => `/chatbot/${kbId}/preview`
  },
  {
    id: 'define_personality',
    apiIds: ['define_personality', 'make_it_your_own'],
    title: 'Make it yours',
    description: 'Give your Agent a personality and tone.',
    completedTitle: 'Love it. Your Agent has character now',
    completedDescription: 'Next up, teach it even more.',
    getPath: (kbId) => `/chatbot/${kbId}/personality`
  },
  {
    id: 'add_knowledge',
    apiIds: ['add_memory'],
    title: 'Teach it more',
    description: 'Upload a file or add another webpage.',
    completedTitle: 'Your Agent is getting smarter',
    completedDescription: 'The more you feed it, the better it gets.',
    getPath: (kbId) => `/chatbot/${kbId}/knowledge`
  },
  {
    id: 'customize_agent',
    apiIds: ['customize_agent'],
    title: 'Customize your Agent',
    description: 'Add your brand colors, logo, and fonts.',
    completedTitle: 'Looking good. That\'s your brand now',
    completedDescription: 'Ready to put it to work?',
    getPath: (kbId) => `/chatbot/${kbId}/styling`
  },
  {
    id: 'deploy_chatbot',
    apiIds: ['deploy_chatbot'],
    title: 'Put your Agent to work',
    description: 'Create a deployment and share it.',
    completedTitle: 'You\'re live. That was quick',
    completedDescription: 'Pick a sharing option to spread the word.',
    getPath: (kbId) => `/chatbot/${kbId}/deployments`
  },
  {
    id: 'first_real_conversation',
    apiIds: ['first_real_conversation'],
    title: 'Talk to your Agent',
    description: 'See your agent the way your customers will. Click Preview to try it out.',
    completedTitle: 'Your Agent just helped someone real',
    completedDescription: 'Chat history saved. You can review it.',
    getPath: (kbId) => `/chatbot/${kbId}/deployments`
  },
  {
    id: 'view_insights',
    apiIds: ['view_insights'],
    title: 'Preview your insights',
    description: 'See a sample conversation in action.',
    completedTitle: 'Now you can see what it sees',
    completedDescription: 'Track how your Agent performs over time.',
    getPath: (kbId) => `/chatbot/${kbId}/insights/records`
  },
  {
    id: 'upgrade_step',
    apiIds: ['upgrade_step'],
    title: 'Unlock full power',
    description: 'Get full chat history and advanced tools.',
    completedTitle: 'You\'ve unlocked everything',
    completedDescription: 'Full chat history and premium tools are on.',
  },
  {
    id:'onboarding_complete',
    apiIds: ['onboarding_complete'],
    title: 'Setup complete',
    description: 'You\'re ready. Close this to get started.',
    completedTitle: 'You did it. Your Agent is ready',
    completedDescription: 'Close this panel and enjoy.',
  }

];
